<template>
  <F360ScreenFrame fill class="insights-agente-body-frame">
    <div class="insight-processando-frame">
      <div class="insight-processando-frame__content">
        <div class="insight-processando-frame__content-icon">
          <MaterialIcon icon="check_circle" />
        </div>
        <div class="insight-processando-frame__content-text">
          <h3>Agente de DRE ativado com sucesso</h3>
          <h5 class="subtitle">As análises serão geradas automaticamente.</h5>
          <p>Estamos analisando os fechamentos de DRE.</p>
          <p>Em alguns minutos, os insights estarão disponíveis aqui.</p>

          <div class="box-loading" v-if="mensagemShow">
            <div class="loading-text">
              <!-- <div v-loading="true" class="loading-icon"></div> -->
              <Transition name="loading-message" mode="out-in">
                <p :key="mensagemShow">{{ mensagemShow }}</p>
              </Transition>
            </div>
            <!-- <div class="button-loading" v-if="mensagemShow === mensagemFinal">
              <F360Button filled prefix-icon="refresh" @click="handleAtualizar"
                >Atualizar</F360Button
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </F360ScreenFrame>
</template>

<script setup lang="ts">
import F360ScreenFrame from "@/ui/components/Layout/Main/ScreenFrame/F360ScreenFrame.vue";
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import { useAgenteDeDreInsigthsStore } from "../../store/useAgenteDeDreInsigthsStore";
import { storeToRefs } from "pinia";
import { computed, onUnmounted, watch } from "vue";

const MENSAGEM_INTERVAL_MS = 3000;
const POLLING_INTERVAL_MS = 20000;

const agenteDeDreInsigthsStore = useAgenteDeDreInsigthsStore();
const { processando, mensagensLoading, mensagemShow } = storeToRefs(
  agenteDeDreInsigthsStore
);

const mensagemFinal = computed(
  () => mensagensLoading.value[mensagensLoading.value.length - 1]
);

let mensagemIntervalId: ReturnType<typeof setInterval> | null = null;
let pollingIntervalId: ReturnType<typeof setInterval> | null = null;

const pararRotacaoMensagens = () => {
  if (!mensagemIntervalId) {
    return;
  }

  clearInterval(mensagemIntervalId);
  mensagemIntervalId = null;
};

const iniciarRotacaoMensagens = () => {
  pararRotacaoMensagens();

  let indice = 0;
  const ultimoIndiceDuranteLoading = mensagensLoading.value.length - 2;

  agenteDeDreInsigthsStore.setMensagemShow(mensagensLoading.value[indice]);

  mensagemIntervalId = setInterval(() => {
    indice = indice >= ultimoIndiceDuranteLoading ? 0 : indice + 1;
    agenteDeDreInsigthsStore.setMensagemShow(mensagensLoading.value[indice]);
  }, MENSAGEM_INTERVAL_MS);
};

const pararPolling = () => {
  if (!pollingIntervalId) {
    return;
  }

  clearInterval(pollingIntervalId);
  pollingIntervalId = null;
};

const consultarStatusGeracao = async () => {
  try {
    const result = await agenteDeDreInsigthsStore.gateway.obterConfiguracao();

    if (result.isFailure) {
      return;
    }

    const configuracao = result.getValue();

    if (!configuracao.agenteLigado) {
      agenteDeDreInsigthsStore.setAtivado(false);
      agenteDeDreInsigthsStore.setProcessando(false);
      pararPolling();

      return;
    }

    agenteDeDreInsigthsStore.setAtivado(configuracao.agenteLigado);
    agenteDeDreInsigthsStore.setIdModeloDRE(configuracao.idModeloDRE);
    agenteDeDreInsigthsStore.setDiaGeracaoRelatorio(
      configuracao.diaGeracaoRelatorio
    );

    if (configuracao.primeiraGeracao) {
      agenteDeDreInsigthsStore.setProcessando(true);

      return;
    }

    agenteDeDreInsigthsStore.setProcessando(false);
    agenteDeDreInsigthsStore.setMensagemShow(mensagemFinal.value);
    pararPolling();

    await agenteDeDreInsigthsStore.fetchGetAgenteDeDre();
  } catch (error) {
    console.error(error);
  }
};

const iniciarPolling = () => {
  pararPolling();

  consultarStatusGeracao();

  pollingIntervalId = setInterval(() => {
    consultarStatusGeracao();
  }, POLLING_INTERVAL_MS);
};

watch(
  processando,
  (estaProcessando) => {
    if (estaProcessando) {
      iniciarRotacaoMensagens();
      iniciarPolling();

      return;
    }

    pararRotacaoMensagens();
    pararPolling();
    agenteDeDreInsigthsStore.setMensagemShow(mensagemFinal.value);
  },
  { immediate: true }
);

onUnmounted(() => {
  pararRotacaoMensagens();
  pararPolling();
});
</script>

<style lang="scss">
.insight-processando-frame {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 0;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    &-icon {
      width: 40px;
      height: 40px;
      background-color: _map.get($map: $azulPrincipal, $key: 700);
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 8px;

      h3,
      .subtitle,
      p {
        margin: 0;
        padding: 0;
      }

      .subtitle {
        font-size: 14px;
        font-weight: 600;
        color: _map.get($map: $azulPrincipal, $key: 700);
      }

      p {
        font-size: 14px;
      }

      .box-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 8px;

        .loading-icon {
          width: 100%;
          height: 40px;
          margin-bottom: 10px;
          margin-top: 0px;
        }

        .loading-text {
          text-align: center;
          color: _map.get($map: $neutro, $key: 300);
          margin-bottom: 10px;
        }

        .loading-message-enter-active,
        .loading-message-leave-active {
          transition: opacity 0.8s ease;
        }

        .loading-message-enter-from,
        .loading-message-leave-to {
          opacity: 0;
        }

        .box {
          width: 230px;
          height: 72px;
          border-radius: 5px;
          gap: 24px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 10px;
          border: 1px solid _map.get($map: $azulPrincipal, $key: 700);

          .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            color: _map.get($map: $azulPrincipal, $key: 700);
            padding: 26px;
          }

          .content {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 5px;

            .title {
              font-size: 14px;
              font-weight: 600;
              color: _map.get($map: $neutro, $key: 700);
            }

            .subtitle {
              font-size: 16px;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
</style>
